<div class="app-shell">
  <main class="container-fluid terminal-main">
    <app-alerta-mensagem [mensagem]="mensagem"></app-alerta-mensagem>
    <ng-content></ng-content>
  </main>
</div>
